import {AfterViewInit, Component, OnDestroy, TemplateRef, ViewChild} from '@angular/core';
import {StorageService} from '../../../services/storage/storage.service';
import {RouteService} from '../../../services/route/route.service';
import {TransactionFilter, TransactionList, TransactionsService} from '../../../services/transactions/transactions.service';
import {CartService} from '../../../services/cart/cart.service';
import {SnackService} from '../../../services/snack/snack.service';
import {AuthService} from '../../../services/auth/auth.service';
import {EventService} from '../../../services/event/event.service';
import {cloneDeep, find} from 'lodash-es';
import moment from 'moment';
import {
  LegacyTicket,
  PaymentMulti,
  PaymentTypeEnum,
  Period,
  PurchaseTransaction,
  SortOrderEnum,
  TransactionSortBy,
  TranslationValue
} from '../../../generated/sales-terminal-client';
import {CustomerService} from '../../../services/customer/customer.service';
import {MatDialog} from '@angular/material/dialog';
import {InvoiceGenerateModalComponent} from './invoice-modal/invoice-generate-modal.component';
import {InvoiceService} from '../../../services/invoice/invoice.service';
import {ValidationService} from '../../../services/validation/validation.service';
import {TranslateService} from '@ngx-translate/core';
import {NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ViewService} from '../../../services/view/view.service';
import {finalize} from 'rxjs/operators';
import {Privileges} from '../../admin/privileges/privileges.constants';
import {SortByOption, TransactionListSortByOption} from '../../../interfaces/sort-by-option.interface';
import {UtilService} from '../../../services/util/util.service';
import {DataTable, DataTableRowItemType} from "../../../components/data-table/data-table.interfaces";
import {MatTabGroup} from "@angular/material/tabs";

interface ReportHeader {
  title: string;
  subTitle?: {
    title: string;
    visible?: boolean;
  };
  visible?: boolean;
  align?: string;
  width?: number;
  noWrap?: boolean;
}

interface TransactionEventInfo {
  name?: TranslationValue[];
  date?: Period;
  sectors?: TransactionSectorInfo[];
}
interface TransactionSectorInfo {
  sectorName?: string;
  rows?: TransactionRowInfo[];
}
interface TransactionRowInfo {
  row?: string;
  seats?: string[];
}

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements AfterViewInit, OnDestroy {
  static STORAGE_SEARCH_RESULTS_PAGE_SIZE = 'transactionsResults.pageSize';
  static STORAGE_SEARCH_RESULTS_PAGE = 'transactionsResults.page';
  static STORAGE_SEARCH_RESULTS_SORT_BY = 'transactionsResults.sortBy';
  static STORAGE_SEARCH_RESULTS_FILTERS = 'transactionsResults.filters';

  @ViewChild('tableTime')
  tableTime: TemplateRef<any>;
  @ViewChild('tablePaymentType')
  tablePaymentType: TemplateRef<any>;
  @ViewChild('tablePaymentMethod')
  tablePaymentMethod: TemplateRef<any>;
  @ViewChild('tableReleaseType')
  tableReleaseType: TemplateRef<any>;
  @ViewChild('tableEvent')
  tableEvent: TemplateRef<any>;
  @ViewChild('tableCustomer')
  tableCustomer: TemplateRef<any>;
  @ViewChild('tableSectors')
  tableSectors: TemplateRef<any>;
  @ViewChild('tableRows')
  tableRows: TemplateRef<any>;
  @ViewChild('tableSeats')
  tableSeats: TemplateRef<any>;
  @ViewChild('tableSeller')
  tableSeller: TemplateRef<any>;
  @ViewChild('tableSalespoint')
  tableSalespoint: TemplateRef<any>;
  @ViewChild('tableTicketQuantity')
  tableTicketQuantity: TemplateRef<any>;
  @ViewChild('tableTotal')
  tableTotal: TemplateRef<any>;

  @ViewChild('tabGroup') tabGroupElement: MatTabGroup;

  public tab: number = 0;
  public filters: TransactionFilter;

  public results: TransactionList = {transactions: [], total: 0, filter: {}};
  public sortByOptions: TransactionListSortByOption[] = [
    {id: 1, field: TransactionSortBy.Date, order: SortOrderEnum.Desc, title: 'general.api_transactions_sort_by_newest'},
    {id: 2, field: TransactionSortBy.Date, order: SortOrderEnum.Asc, title: 'general.api_transactions_sort_by_oldest'}
  ];
  public sortByOptionsLegacy: SortByOption[] = [
    {id: 1, field: 'dateStart', order: SortOrderEnum.Desc, title: 'general.api_transactions_sort_by_newest'},
    {id: 2, field: 'dateStart', order: SortOrderEnum.Asc, title: 'general.api_transactions_sort_by_oldest'}
  ];
  public sortBy: number = this.sortByOptions[1].id;
  public pageSizeOptions: number[] = [30, 60, 90];
  public pageSize: number = this.pageSizeOptions[0];
  public page = 1;
  public isLoading = false;
  public noSearches = true;
  public transactionsEventList: TransactionEventInfo[][] = [];
  public sectorsPerTransaction: TransactionSectorInfo[][] = [];
  public invoiceGenerateInProgress = false;
  public showMobileFilters: boolean = false;
  public expandedTransactions: number[] = [];
  private _subscriptions: Subscription[] = [];
  public Privileges = Privileges;

  public dataTableConfig: DataTable;

  constructor(public cartService: CartService,
              public eventService: EventService,
              public customerService: CustomerService,
              public authService: AuthService,
              public invoiceService: InvoiceService,
              public validationService: ValidationService,
              public viewService: ViewService,
              public utilService: UtilService,
              private dialog: MatDialog,
              private routeService: RouteService,
              private snackService: SnackService,
              private transactionsService: TransactionsService,
              private translateService: TranslateService,
              private storageService: StorageService,
              private router: Router) {
    if (storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_PAGE_SIZE)) {
      this.pageSize = parseInt(storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_PAGE_SIZE), 0);
    }
    if (storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_PAGE)) {
      this.page = parseInt(storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_PAGE), 0);
    }
    if (storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_SORT_BY)) {
      this.sortBy = parseInt(storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_SORT_BY), 0);
    }
    this._subscriptions.push(router.events.subscribe((event) => {
      if (this.isComponentReload(event)) {
        this.tab = this.isLive ? 1 : 0;
        if (this.results.total !== 0) {
          setTimeout(() => {
            if (storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_FILTERS)) {
              this.filters = JSON.parse(storageService.get(TransactionsComponent.STORAGE_SEARCH_RESULTS_FILTERS));
            }
            this.search(this.page);
          }, 0);
        }
        this.setup();
      }
    }));
  }

  public get isLive(): boolean {
    return !this.viewService.conf.environment?.length;
  }

  public get isLegacy(): boolean {
    return this.isLive || this.routeService.checkRoute( ['sales-terminal', 'transactions', 'legacy']);
  }

  private isComponentReload(event: any): boolean {
    return event instanceof NavigationEnd &&
      event.url === '/app/sales-terminal/transactions'
  }

  public ngAfterViewInit(): void {
    if (this.isLegacy) {
      this.tab = 1;
    }
    this.setup();
  }

  public setup(): void {
    this.dataTableConfig = {
      header: {
        items: [
          {
            key: 'transaction_id',
            format: 'general.api_transactions_transaction_id'
          },
          {
            key: 'table_time',
            format: 'general.api_transactions_table_time'
          },
          {
            key: 'payment_type',
            format: 'general.api_reports_payment_type',
            children: [{
              key: 'release_type',
              format: 'general.api_reports_release_type',
              cssClass: 'subtitle',
              isHidden: !this.isLegacy
            }, {
              key: 'payment_method',
              format: 'general.api_transactions_payment_method',
              cssClass: 'subtitle',
              isHidden: this.isLegacy
            }],
            cssClass: 'white-space-no-wrap'
          },
          {
            key: 'buyer',
            format: 'general.api_reports_buyer',
            children: [{
              key: 'buyer_email',
              format: 'general.api_reports_buyer_email',
              cssClass: 'subtitle'
            }, {
              key: 'delivery_email',
              format: 'general.api_transactions_delivery_email',
              cssClass: 'subtitle'
            }]
          },
          {
            key: 'event',
            format: 'general.api_reports_event',
            children: [{
              key: 'event_date_start',
              format: 'general.api_reports_event_date_start',
              cssClass: 'subtitle'
            }],
            width: 20
          },
          {
            key: 'sector',
            format: 'general.api_cart_table_sector',
            isHidden: !this.isLegacy
          },
          {
            key: 'row',
            format: 'general.api_cart_table_row',
            isHidden: !this.isLegacy
          },
          {
            key: 'seat',
            format: 'general.api_cart_table_seat',
            isHidden: !this.isLegacy
          },
          {
            key: 'seller',
            format: 'general.api_reports_seller',
            children: [{
              key: 'salespoint',
              format: 'general.api_reports_salespoint',
              cssClass: 'subtitle'
            }]
          },
          {
            key: 'reservation',
            format: 'general.api_transactions_table_reservation',
            isHidden: !this.isLegacy
          },
          {
            key: 'items_total',
            format: 'general.api_cart_table_items_total',
            cssClass: 'align-right',
            width: 1
          },
          {
            key: 'total',
            format: 'general.api_transactions_table_total',
            cssClass: 'align-right',
          },
          {
            key: 'buttons'
          }
        ]
      },
      body: {
        items: [
          {
            key: 'transaction_id',
            format: 'id',
            useModel: true,
            type: DataTableRowItemType.Link,
            action: (item: any) => {
              this.openTransaction(item);
            }
          },
          {
            key: 'table_time',
            type: DataTableRowItemType.Template,
            template: this.tableTime
          },
          {
            key: 'payment_type',
            type: DataTableRowItemType.Template,
            template: this.tablePaymentType,
            children: [{
              key: 'release_type',
              type: DataTableRowItemType.Template,
              template: this.tableReleaseType,
              isHidden: !this.isLegacy
            }, {
              key: 'payment_method',
              type: DataTableRowItemType.Template,
              template: this.tablePaymentMethod,
              isHidden: this.isLegacy
            }],
            cssClass: 'white-space-no-wrap'
          },
          {
            key: 'buyer',
            type: DataTableRowItemType.Template,
            template: this.tableCustomer,
            children: [{
              key: 'buyer_email',
              format: 'email',
              useModel: true,
              isHidden: (item: any) => {
                return item?.email === item?.customer?.email
              },
              cssClass: 'display-block'
            }],
          },
          {
            key: 'event',
            type: DataTableRowItemType.Template,
            template: this.tableEvent,
          },
          {
            key: 'sector',
            type: DataTableRowItemType.Template,
            template: this.tableSectors,
            isHidden: !this.isLegacy
          },
          {
            key: 'row',
            type: DataTableRowItemType.Template,
            template: this.tableRows,
            cssClass: 'white-space-no-wrap',
            isHidden: !this.isLegacy
          },
          {
            key: 'seat',
            type: DataTableRowItemType.Template,
            template: this.tableSeats,
            cssClass: 'white-space-no-wrap',
            isHidden: !this.isLegacy
          },
          {
            key: 'seller',
            type: DataTableRowItemType.Template,
            template: this.tableSeller,
            children: [{
              key: 'salespoint',
              type: DataTableRowItemType.Template,
              template: this.tableSalespoint
            }]
          },
          {
            key: 'reservation',
            format: 'bookingNr',
            useModel: true,
            isHidden: !this.isLegacy
          },
          {
            key: 'items_total',
            type: DataTableRowItemType.Template,
            template: this.tableTicketQuantity,
            cssClass: 'align-right',
            width: 1
          },
          {
            key: 'total',
            type: DataTableRowItemType.Template,
            template: this.tableTotal,
            cssClass: 'align-right',
          },
          {
            key: 'buttons',
            type: DataTableRowItemType.Button,
            cssClass: 'align-right white-space-no-wrap',
            buttons: [
              {
                isHidden: (item: any) => {
                  return (!this.isLegacy && !item.isTransactionOwner) || !this.authService.checkPrivileges(Privileges.INVOICE_GENERATE) || this.invoiceGenerateInProgress
                },
                checkModel: '!item.invoiceUuid',
                action: (item: any) => {
                  this.openGenerateInvoiceModal(item);
                },
                tooltip: 'general.api_transactions_generate_invoice',
                icon: 'invoice',
                cssClass: 'right-spacer'
              },
              {
                isHidden: (item: any) => {
                  return (!this.isLegacy && !item.isTransactionOwner) || this.invoiceGenerateInProgress
                },
                checkModel: 'item.invoiceUuid',
                action: (item: any) => {
                  this.openGenerateInvoiceModal(item);
                },
                tooltip: this.invoiceViewEditTranslation,
                icon: 'invoice',
                color: 'accent',
                cssClass: 'right-spacer'
              },
              {
                isHidden: this.invoiceGenerateInProgress,
                action: (item: any) => {
                  this.openTransaction(item);
                },
                icon: 'arrow_right'
              }
            ]
          }
        ]
      }
    };
  }

  public get sort(): SortByOption | TransactionListSortByOption {
    return find(this.tab === 0 ? this.sortByOptions : this.sortByOptionsLegacy, {id: this.sortBy});
  }

  public get isTransactionView(): boolean {
    return this.routeService.checkRoute(['sales-terminal', 'transactions', 'view']) || this.routeService.checkRoute(['sales-terminal', 'transactions', 'legacy', 'view']);
  }

  public openTransaction(transaction: PurchaseTransaction): void {
    this.routeService.navigate('/app/sales-terminal/transactions/' + (this.tab === 1 ? 'legacy/' : '') + 'view/' + transaction.id);
  }

  // Optimized solution for displaying events, sectors, rows and seats in transaction list
  private makeEventList(): void {
    this.transactionsEventList = [];
    this.sectorsPerTransaction = [];
    this.results.transactions.forEach((transaction) => {
      const eventList: number[] = [];
      const eventInfo: TransactionEventInfo[] = [];
      transaction.cart.events.forEach(event => {
        eventList.push(event.id);
        eventInfo.push({
          name: event.title,
          date: event.eventDate,
          sectors: []
        });
        (event.legacyTickets || []).forEach((ticket: LegacyTicket) => {
          let eventIndex: number = eventList.indexOf(event.id);
          let sectorIndex: number = eventInfo[eventIndex].sectors.findIndex((sector) => sector.sectorName === ticket.sectorName);
          if (sectorIndex === -1) {
            eventInfo[eventIndex].sectors.push({
              sectorName: ticket.sectorName,
              rows: []
            });
            sectorIndex = eventInfo[eventIndex].sectors.length - 1;
          }
          let rowIndex: number = eventInfo[eventIndex].sectors[sectorIndex].rows.findIndex((row) => row.row === ticket.row);
          if (rowIndex === -1) {
            eventInfo[eventIndex].sectors[sectorIndex].rows.push({
              row: ticket.row,
              seats: []
            });
            rowIndex = eventInfo[eventIndex].sectors[sectorIndex].rows.length - 1;
          }
          if (ticket.place) {
            eventInfo[eventIndex].sectors[sectorIndex].rows[rowIndex].seats.push(ticket.place);
          }
        });
      })
      this.transactionsEventList.push(eventInfo);
      let sectors: TransactionSectorInfo[] = [];
      eventInfo.forEach((element) => {
        sectors = sectors.concat(element.sectors);
      });
      this.sectorsPerTransaction.push(sectors);
    });
  }

  public search(page = 1): void {
    this.expandedTransactions = [];
    this.showMobileFilters = false;
    this.isLoading = true;
    this.noSearches = false;
    this.results = {transactions: [], total: 0, filter: {}};
    this.page = page;
    const filters = cloneDeep(this.filters);
    if (filters.dateStart) {
      filters.dateStart = moment(filters.dateStart).format('YYYY-MM-DD');
    }
    const diff: number = moment(filters.dateEnd).diff(filters.dateStart, 'days');
    if (diff < 0) {
      filters.dateEnd = filters.dateStart;
    }
    if (filters.dateEnd) {
      filters.dateEnd = moment(filters.dateEnd).format('YYYY-MM-DD');
    }
    const searchSub = this.transactionsService[!this.isLegacy ? 'search' : 'searchLegacy']({
      page: this.page,
      pageSize: this.pageSize,
      sortBy: this.sort.field,
      sortOrder: this.sort.order,
      filters: filters
    }).pipe(
      finalize(() => this.isLoading = false)
    ).subscribe((result: TransactionList) => {
      this.results = result;
      if (this.results.filter) {
        this.filters = cloneDeep(this.results.filter);
      }
      this.storageService.set(TransactionsComponent.STORAGE_SEARCH_RESULTS_FILTERS, JSON.stringify(this.filters));
      this.makeEventList();
    });
    this._subscriptions.push(searchSub);
  }

  public changeTab(): void {
    this.routeService.replaceUrl('/app/sales-terminal/transactions' + (this.tab === 1 ? '/legacy' : ''));
    this.results = {transactions: [], total: 0, filter: {}};
    this.filters = {};
    setTimeout(() => {
      this.setup();
    }, 0);
  }

  displaySortWith(id: number): string | undefined {
    return find(this.sortByOptions, {id: id})?.title;
  }

  updateLocalStorage(): void {
    this.search();
    this.storageService.set(TransactionsComponent.STORAGE_SEARCH_RESULTS_SORT_BY, this.sortBy);
    this.storageService.set(TransactionsComponent.STORAGE_SEARCH_RESULTS_PAGE_SIZE, this.pageSize);
  }

  public openGenerateInvoiceModal(transaction: PurchaseTransaction): void {
    const dialogRef = this.dialog.open(InvoiceGenerateModalComponent, {
      maxHeight: '100%',
      width: '70%',
      data: {
        transaction: transaction,
        legacy: this.isLegacy
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.invoiceGenerateInProgress = true;
        this.invoiceService.generateInvoice(transaction.id, result, this.isLegacy).pipe(
          finalize(() => this.invoiceGenerateInProgress = false)
        ).subscribe((generatedInvoice) => {
          transaction.invoiceUuid = generatedInvoice.uuid;
          this.snackService.showSuccess(this.translateService.instant('general.api_invoice_generate_success'));
          this.invoiceService.downloadInvoice(generatedInvoice);
        });
      }
    });
  }

  get invoiceViewEditTranslation(): string {
    if (this.authService.checkPrivileges(Privileges.INVOICE_CHANGE)) {
      return 'general.api_transactions_change_invoice';
    } else {
      return 'general.api_transactions_view_invoice';
    }
  }

  public isTransferPaymentMethod(payments: PaymentMulti[]): boolean {
    return payments.some(payment => payment.type === PaymentTypeEnum.Transfer);
  }

  public expandTransaction(index: number): void {
    this.expandedTransactions.push(index);
  }
  public closeTransaction(index: number): void {
    this.expandedTransactions.splice(this.expandedTransactions.indexOf(index), 1);
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(value => value.unsubscribe());
  }
}
